import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row} from "reactstrap";
import paneller from "../data/paneller";
import {useLocation} from "react-router-dom";
import inverter from "../data/inverter";
import sarjKontrol from "../data/sarjKontrol";
import solarEkipman from "../data/solarEkipman";
import enerjiDepolama from "../data/enerjiDepolama";
import aracSarj from "../data/aracSarj";
import solarPaket from "../data/solarPaket";
import isitma from "../data/isitma";

function Products(props) {
    const location = useLocation();
    const type = location.state?.type;

    const [data, setData] = useState(type === "solar" ? paneller : paneller);
    const [tab, setTab] = useState(1);

    useEffect(() => {
        selectData(type)
    }, []);

    const selectData = (type) => {
        switch (type) {
            case "solar":
                setData(paneller);
                setTab(1);
                break;
            case "inverter":
                setData(inverter);
                setTab(2);
                break;
            case "sarjKontrol":
                setData(sarjKontrol);
                setTab(3);
                break;
            case "solarEkipman":
                setData(solarEkipman);
                setTab(4);
                break;
            case "enerjiDepolama":
                setData(enerjiDepolama);
                setTab(5);
                break;
            case "aracSarj":
                setData(aracSarj);
                setTab(6);
                break;
            case "solarPaket":
                setData(solarPaket);
                setTab(7);
                break;
            case "isitma":
                setData(isitma);
                setTab(8);
                break;
            default:
                setData(paneller);
                setTab(1);
        }

    }


    return (
        <>
            <Container>
                <div className="section text-center">
                    <Container>
                        <Row
                            style={{marginTop: '10%', justifyContent: 'center', display: 'flex', alignItems: 'center'}}>
                            <Col className="ml-auto mr-auto">
                                <h2 className="title">Ürünler</h2>
                                <h5 className="description">
                                    Ürünlerimiz hakkında daha fazla bilgi almak veya ihtiyaçlarınıza özel bir çözüm
                                    oluşturmak için bizimle iletişime geçebilirsiniz.
                                    Ekibimiz, size en uygun solar enerji sistemini sunmak için hazır. Detaylar ve teklif
                                    talepleri için hemen ulaşın.
                                </h5>
                                <br/>
                                <Button
                                    className="btn-round"
                                    color="info"
                                >
                                    İletişim
                                </Button>
                            </Col>
                        </Row>
                        <br/>
                        <br/>
                        <Row className="d-flex align-items-center justify-content-center gap-5 mb-5">
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"info product-box"} style={{
                                    border: tab === 1 && "5px solid #2196F3",
                                    background: tab === 1 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("solar")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/solar-energy.png")}
                                            alt="Güneş Paneli Fiyatları ve Solar Güneş Panelleri"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Solar Paneller</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 2 && "5px solid #2196F3",
                                    background: tab === 2 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("inverter")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/inverter-icon.png")}
                                            className="img-fluid" alt="İnverter Çeşitleri &amp; Fiyatları"/></div>
                                    <div className="description">
                                        <h4 className="info-title">İnverterler</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 3 && "5px solid #2196F3",
                                    background: tab === 3 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("sarjKontrol")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/battery.png")}
                                            className="img-fluid" alt="İnverter Çeşitleri &amp; Fiyatları"/></div>
                                    <div className="description">
                                        <h4 className="info-title">Şarj Kontrol Cihazları</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 4 && "5px solid #2196F3",
                                    background: tab === 4 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("solarEkipman")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/solar_equipments.png")}
                                            className="img-fluid" alt="İnverter Çeşitleri &amp; Fiyatları"/></div>
                                    <div className="description">
                                        <h4 className="info-title">Solar Ekipmanlar</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 5 && "5px solid #2196F3",
                                    background: tab === 5 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("enerjiDepolama")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/inverter.png")}
                                            className="img-fluid" alt="İnverter Çeşitleri &amp; Fiyatları"/></div>
                                    <div className="description">
                                        <h4 className="info-title">Enerji Depolama Çözümleri</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 6 && "5px solid #2196F3",
                                    background: tab === 6 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("aracSarj")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/car-charge.webp")}
                                            alt="Güneş Paneli Fiyatları ve Solar Güneş Panelleri"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Araç İstasyonları</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 7 && "5px solid #2196F3",
                                    background: tab === 7 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("solarPaket")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/packages-icon.png")}
                                            alt="Güneş Paneli Fiyatları ve Solar Güneş Panelleri"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Solar Paketler</h4>
                                    </div>
                                </div>
                            </Col>
                            <Col xs="5" md="auto" className="d-flex justify-content-center">
                                <div className={"product-box"} style={{
                                    border: tab === 8 && "5px solid #2196F3",
                                    background: tab === 8 && '#E3F2FD'
                                }}
                                     onClick={() => selectData("isitma")}>
                                    <div className="icon icon-info">
                                        <img
                                            style={{height: 90}}
                                            src={require("../assets/products/air-conditioner.png")}
                                            alt="Güneş Paneli Fiyatları ve Solar Güneş Panelleri"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Isıtma Soğutma</h4>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row lg={"3"} className="align-items-stretch">
                            {data.map((item, index) => (<Col className="d-flex">
                                <Cards item={item} key={index}/>
                            </Col>))}

                        </Row>
                    </Container>
                </div>

            </Container>
        </>
    );
}


const Cards = ({item}) => {
    return (
        <div className="card-container h-100 w-100">

            <div className="nft">
                <div className='main'>
                    <img className='tokenImage'
                         src={item.image}
                         alt="NFT"/>
                    <h2>{item.title}</h2>
                    <p className='description'>
                        {item.text}
                    </p>
                    {/*<div className='tokenInfo'>
                        <div className="price">
                            <ins>◘</ins>
                            <p>0.031 ETH</p>
                        </div>
                        <div className="duration">
                            <ins>◷</ins>
                            <p>11 days left</p>
                        </div>
                    </div>*/}
                    <hr/>
                    <div className='creator'>
                        <p>
                            <ins style={{textDecoration: 'underline', cursor: 'pointer'}}>İletişime Geç</ins>
                        </p>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default Products;
